export default __webpack_public_path__ + "static/media/send-package-icon.59e4ed53.svg";